(ns common.schema.entities.workspace.kyc.tenant-kyc-profile.core
  (:require [common.features.plan :as plan]
            [common.schema.entities.permissions :as entity-permissions]
            [common.schema.entities.workspace.kyc.tenant-kyc-profile :as tenant-kyc-profile]))

;; Verbatim copy of common.schema.entity-types's existing tenant-kyc-profile
;; entry (entity_types.cljc around line 1414-1428) - required here, not
;; there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- read-permissions-check-fn
  [{:keys [account-current-permissions tenant role tenant-plan]}]
  (and (plan/available :feature/tenant-kyc tenant role tenant-plan)
       (contains? (:account-modules account-current-permissions)
                  :module/tenant-kyc)))

(def entity-type-definition
  {:entity-type                  :entity.type/tenant-kyc-profile
   :schema                       tenant-kyc-profile/schema
   :name                         {:en "Tenant KYC profile"}
   :plural                       {:en "Tenant KYC profiles"}
   :icon                         :fa-shield-check
   :entity/mcp-blacklisted?      true
   :read-permissions-check-fn    read-permissions-check-fn
   :disable-permissions-check-fn entity-permissions/disable-when-no-write-permission

   ;; Like contract-kyc-profile, tenant-kyc-profile has no pre-existing legacy
   ;; dedicated OpenSearch index (its legacy common.opensearch.entity-indices
   ;; entry is an empty map, "TODO universal indexing"). Leaving
   ;; :search-index? unset lets it default to true (since :search is present
   ;; below), routing dedicated indexing through the newer
   ;; backend.search.dedicated.indexes/init! bootstrap - the index is created
   ;; and re-indexed explicitly as part of this port, matching
   ;; contract-kyc-profile's port (see ai/mistakes.md).
   ;;
   ;; :tenant-kyc-profile/name is a calculated field (composite of just
   ;; :tenant-kyc-profile/target's display string) - it only ever
   ;; materializes into the dedicated OpenSearch index through the modern
   ;; per-entity-type materialization pipeline, which is why the backend
   ;; registration is required. Used here instead of :common/display-name
   ;; for the same reason as contract-kyc-profile: a kanban card's
   ;; title/body only ever reads flat.<alias> paths, and
   ;; :common/display-name is never flattened.
   ;;
   ;; The legacy grid's screening-status column is conditional on
   ;; session/screening? - omitted from the static :list/default-columns
   ;; below, matching contract-kyc-profile's own port.
   :search                       {:result/title-attr :tenant-kyc-profile/name
                                  :list/default-columns [:tenant-kyc-profile/name
                                                         :tenant-kyc-profile/status
                                                         :kyc-profile/risk-category
                                                         :tenant-kyc-profile/next-deadline
                                                         :tenant-kyc-profile/latest-process-status
                                                         :tenant-kyc-profile/their-kyc-contact
                                                         :tenant-kyc-profile/our-kyc-contact]
                                  :views {:grid {:po-default-field-paths [[:tenant-kyc-profile/name]
                                                                          [:tenant-kyc-profile/status]
                                                                          [:kyc-profile/risk-category]
                                                                          [:tenant-kyc-profile/next-deadline]
                                                                          [:tenant-kyc-profile/latest-process-status]
                                                                          [:tenant-kyc-profile/their-kyc-contact]
                                                                          [:tenant-kyc-profile/our-kyc-contact]]
                                                 :mandatory-field-paths [[:tenant-kyc-profile/name]]}}}})
